import {useQuickView} from "@/features/quickView/model/useQuickView";
import {Svg} from "@/shared/ui/Svg";
import {Button} from "@/shared/ui/Button";
import styles from "./QuickViewButton.module.scss";

type Props = {
    article: string;
};

export const QuickViewButton = ({article, ...buttonProps}: Props) => {
    const {openQuickView, loading} = useQuickView();

    return (
        <Button
            {...buttonProps}
            loading={loading}
            variant={`icon`}
            className={styles.button}
            onClick={() => openQuickView(article)}
        >
            <Svg id={`quick-view`} className={styles.svg} />
        </Button>
    );
};
